import WorkflowStep from "../../../formability/form_builder/models/workflow/workflowStep";
import ValidationError from "../validationError";
import {WorkflowType} from "../../enums/forms/workflowSteps/workflowType";
import {ErrorType} from "~/enums/ErrorType";
import {PermitteeType} from "~/enums/permitteeType";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";
import {LookupFieldType} from "~/enums/lookupFieldType";
import { ObjectModelRecordHolderType } from "~/enums/objectModelRecordHolderType";
import FormElement, { IFormElement } from '../../../formability/form_builder/models/formElements/formElement';

export default class WorkflowStepCompleterValidator extends NavigableValidator<WorkflowStep> {
  _validatorKey = "hasOneCompleter";
  defaultType = ErrorType.invalidValue;
  gatheredStepIds = [];

  _validate(model: WorkflowStep): void {
    const completerTypes = [WorkflowType.payment, WorkflowType.form, WorkflowType.approval, WorkflowType.formSection];
    if (completerTypes.includes(model.workflow_type)) {
      if (!model.submitter.reference_id && model.submitter.reference_type !== PermitteeType.originalSubmitter) {
        this.errors.push(this.buildValidationError(model, 'At least one step completer must be assigned'));
        return;
      }
    }

    if (model.submitter && model.submitter.reference_type === PermitteeType.priorStep) {
      this.gatheredStepIds = [];
      this.getPriorStep(model, model);
    }

    if (model.submitter && model.submitter.reference_type === PermitteeType.lookupField) {
      let lookupField: FormElement;
      for (const formSectionStep of model.previousWorkflowStepsWithFormSection) {
        lookupField = formSectionStep.findElement(model.submitter.reference_id);

        if (lookupField) break;
      }

      let errorMessage: string;
      if (!lookupField) {
        errorMessage = 'Step completer must reference a step that goes before the current step';
      } else if (lookupField.lookup_type !== LookupFieldType.objectModels) {
        errorMessage = 'Step completer lookup field must lookup Object Model data';
      } else if (lookupField.object_model_instance_selection_limit !== 1) {
        errorMessage = 'Step completer lookup field must have a record selection limit of one (1)';
      } else if (lookupField.object_model.holder_type === ObjectModelRecordHolderType.None) {
        errorMessage = 'Step completer lookup field cannot reference an Object Model configured to have no record holder';
      }

      if (errorMessage) {
        this.errors.push(this.buildValidationError(model, errorMessage, ErrorType.invalidValue));
      }
    }
  }

  getPriorStep(model: WorkflowStep, originalModel: WorkflowStep): WorkflowStep {
    if (model.submitter.reference_type !== PermitteeType.priorStep) {
      return;
    }

    if (this.gatheredStepIds.includes(model.client_id)) {
      // circular reference detected
      this.errors.push(this.buildValidationError(originalModel, 'Prior step cannot reference itself', ErrorType.circularReference));
      this.gatheredStepIds = [];
      return;
    }

    this.gatheredStepIds.push(model.client_id);

    const previousWorkflowStep = model.previousWorkflowStepsWithCompleter.find(ws => ws.id === model.submitter.reference_id);

    if (!previousWorkflowStep) {
      // referenced step can't be found, probably moved or deleted
      this.errors.push(this.buildValidationError(originalModel, 'Step completer must reference a step that goes before the current step'));
      return null;
    }

    return this.getPriorStep(previousWorkflowStep, originalModel);
  }

  buildValidationError(model: WorkflowStep, value?, type?) {
    return new ValidationError({
      message: value || this.options.message || this.defaultMessage,
      displayName: `${model.titleOrDefault} (step)`,
      errorNavOpts: model.validation.errorNavOpts(this, this.validatorKey, model),
      type: type || this.defaultType,
      section: this.section
    });
  }
}